import React from "react";

import { AW21 } from "../../../../js/database/database-aw21.js";

import TopMenuProducts from "../../../../components/topmenuproducts";
import SwiperInit from "../../../../components/SwiperInit";
import InfoItem from "../../../../components/infoItem";
import Loader from "../../../../components/loader";

import ShopifyMainComponent from "../../../../components/ShopifyMainComponent";
import GlobalMetaTags from "../../../../components/globalMetaTags";
import SizeChart from "../../../../components/sizeChart.js";

class PeepholeLeatherTank extends React.Component {

    render() {
        return (
            <div>
                <GlobalMetaTags
                    pageTitle={AW21.tops.PeepholeLeatherTank.itemName}
                />
                <Loader />
                <TopMenuProducts
                    name={AW21.tops.PeepholeLeatherTank.itemName}
                />
                <InfoItem
                    price={AW21.tops.PeepholeLeatherTank.itemPrice}
                    fabric={AW21.tops.PeepholeLeatherTank.itemFabric}
                />
                <SizeChart src={AW21.tops.PeepholeLeatherTank.sizeChart} />
                <div className="swiper-container" id="swiper">
                    <div className="swiper-wrapper">
                        <div className="swiper-slide">
                            <img
                                src={AW21.tops.PeepholeLeatherTank.picture01}
                                alt={AW21.alt}
                                width={AW21.imgWidth}
                                height={AW21.imgHeight}
                                loading="lazy"
                            />
                        </div>
                        <div className="swiper-slide">
                            <img
                                src={AW21.tops.PeepholeLeatherTank.picture02}
                                alt={AW21.alt}
                                width={AW21.imgWidth}
                                height={AW21.imgHeight}
                                loading="lazy"
                            />
                        </div>
                        <div className="swiper-slide">
                            <img
                                src={AW21.tops.PeepholeLeatherTank.picture03}
                                alt={AW21.alt}
                                width={AW21.imgWidth}
                                height={AW21.imgHeight}
                                loading="lazy"
                            />
                        </div>
                        <div className="swiper-slide">
                            <img
                                src={AW21.tops.PeepholeLeatherTank.picture04}
                                alt={AW21.alt}
                                width={AW21.imgWidth}
                                height={AW21.imgHeight}
                                loading="lazy"
                            />
                        </div>

                    </div>
                </div>
                <ShopifyMainComponent
                    divId={AW21.tops.PeepholeLeatherTank.shopifyDivId}
                    mainId={AW21.tops.PeepholeLeatherTank.shopifyId}
                />
                <SwiperInit />
            </div>
        );
    }
}

export default PeepholeLeatherTank;
